module.exports = __webpack_public_path__ + "img/banner.96ec32d4.png";